export const videos = [
  {
    id: "mv-001",
    title: "星海孤舟",
    type: "电影",
    genre: ["科幻", "冒险", "剧情"],
    region: "中国大陆",
    year: 2025,
    updatedAt: "2025-09-28",
    episodes: "正片",
    rating: 8.7,
    heat: 9860,
    cover: "https://readdy.ai/api/search-image?query=Cinematic%20sci-fi%20movie%20poster%20of%20a%20lone%20astronaut%20before%20a%20glowing%20star%20map%2C%20deep%20space%20nebula%20background%2C%20warm%20orange%20and%20teal%20color%20grading%2C%20dramatic%20rim%20light%2C%20high%20detail%20minimal%20composition%2C%20moody%20atmosphere&width=400&height=600&seq=bale-mv-001&orientation=portrait",
    banner: "https://readdy.ai/api/search-image?query=Epic%20sci-fi%20film%20key%20art%20of%20a%20tiny%20spaceship%20drifting%20through%20a%20vast%20orange%20nebula%2C%20cinematic%20wide%20shot%2C%20dark%20vignette%20edges%20for%20text%20overlay%2C%20dramatic%20volumetric%20light%2C%20high%20detail%20digital%20painting&width=1600&height=900&seq=bale-bn-001&orientation=landscape",
    summary: "一艘失联的深空探测船，载着最后一名船员穿越未知星域，只为把人类的信号带回地球。",
    description: "公元 2137 年，深空探测船“孤舟号”在完成一次跃迁后与地面彻底失联。唯一幸存的导航员林澈必须在氧气与燃料耗尽前，独自修复损坏的导航核心，穿越一片从未被记录的星域。一路上，他通过残存的航行日志重新拼凑出船队失事的真相，也逐渐直面自己被留下的原因。影片以极简的太空场景与克制的表演，讲述一个人与宇宙、与记忆之间的漫长对话。",
    actors: ["林澈 饰 江野", "苏晚 饰 沈知遥", "陈望 饰 老周"],
    director: "陆知远",
  },
  {
    id: "mv-002",
    title: "长安夜雨",
    type: "电影",
    genre: ["悬疑", "犯罪", "剧情"],
    region: "中国大陆",
    year: 2024,
    updatedAt: "2024-11-12",
    episodes: "正片",
    rating: 8.2,
    heat: 9120,
    cover: "https://readdy.ai/api/search-image?query=Moody%20historical%20mystery%20movie%20poster%20of%20a%20rainy%20ancient%20Chinese%20city%20street%20at%20night%2C%20lantern%20glow%2C%20silhouette%20of%20a%20detective%20in%20a%20cloak%2C%20reflective%20wet%20stone%2C%20deep%20amber%20and%20charcoal%20tones%2C%20cinematic%20lighting&width=400&height=600&seq=bale-mv-002&orientation=portrait",
    banner: "https://readdy.ai/api/search-image?query=Ancient%20Chinese%20city%20at%20rainy%20night%20with%20rows%20of%20warm%20lanterns%20reflecting%20on%20wet%20cobblestone%2C%20misty%20atmosphere%2C%20dark%20gradient%20sky%20for%20text%2C%20cinematic%20wide%20establishing%20shot%2C%20moody%20amber%20palette&width=1600&height=900&seq=bale-bn-002&orientation=landscape",
    summary: "一场连绵七日的夜雨，一桩二十年悬而未决的旧案，把长安城里两个不愿相识的人推到一起。",
    description: "长安城接连七日大雨，工部一名小吏在城西水渠中被人发现。奉命查案的推事官裴肃发现，死者手中的一枚铜牌竟与二十年前一桩灭门旧案有关。随着调查深入，他不得不与当年负责此案、如今已隐退的老捕头联手。雨夜、密语与层层掩盖的真相交织，当最后一滴雨落下，凶手是谁已不再是最重要的答案。",
    actors: ["裴肃 饰 韩沉", "柳氏 饰 白笙", "老捕头 饰 郑槐"],
    director: "白砚",
  },
  {
    id: "mv-003",
    title: "沉默证词",
    type: "电影",
    genre: ["犯罪", "剧情", "悬疑"],
    region: "中国香港",
    year: 2023,
    updatedAt: "2023-08-19",
    episodes: "正片",
    rating: 7.9,
    heat: 8340,
    cover: "https://readdy.ai/api/search-image?query=Crime%20thriller%20movie%20poster%20with%20a%20lone%20figure%20under%20a%20single%20interrogation%20lamp%2C%20empty%20concrete%20room%2C%20cold%20shadows%2C%20muted%20slate%20tones%20with%20a%20warm%20accent%2C%20tense%20minimal%20composition&width=400&height=600&seq=bale-mv-003&orientation=portrait",
    banner: "https://readdy.ai/api/search-image?query=Empty%20concrete%20interrogation%20room%20with%20a%20single%20hanging%20lamp%20casting%20long%20shadows%2C%20cold%20slate%20and%20warm%20contrast%20light%2C%20dark%20edges%20for%20text%20overlay%2C%20cinematic%20crime%20drama%20key%20art&width=1600&height=900&seq=bale-bn-003&orientation=landscape",
    summary: "唯一的目击者拒绝开口，而案件的倒计时已经开始。",
    description: "一名律师在深夜回家的路上目睹了一起坠楼事件，却在此后对警方三缄其口。负责此案的督察在案件即将移交的前夜，发现所有线索都指向一个早已被结案的名字。为了撬动真相，他必须弄清楚：一个不愿作证的人，究竟是在保护谁，又或者是在害怕什么。",
    actors: ["督察 饰 方卓", "律师 饰 何慕", "嫌疑人 饰 阿七"],
    director: "阮柏",
  },
  {
    id: "mv-004",
    title: "极夜追凶",
    type: "电影",
    genre: ["悬疑", "动作", "犯罪"],
    region: "美国",
    year: 2025,
    updatedAt: "2025-10-02",
    episodes: "正片",
    rating: 8.4,
    heat: 9450,
    cover: "https://readdy.ai/api/search-image?query=Dark%20polar%20thriller%20poster%20of%20a%20snow%20covered%20research%20station%20at%20night%2C%20aurora%20sky%2C%20a%20lone%20silhouette%20with%20a%20flashlight%2C%20cold%20teal%20shadows%20and%20warm%20lamp%20glow%2C%20cinematic%20tension&width=400&height=600&seq=bale-mv-004&orientation=portrait",
    banner: "https://readdy.ai/api/search-image?query=Snow%20covered%20polar%20research%20station%20at%20night%20under%20an%20aurora%20sky%2C%20blue%20hour%20wilderness%2C%20dim%20warm%20windows%2C%20dark%20gradient%20for%20headline%20text%2C%20cinematic%20wide%20shot&width=1600&height=900&seq=bale-bn-004&orientation=landscape",
    summary: "极圈内的长夜里，站员一个接一个失踪，而太阳还要等四十天才升起。",
    description: "一支极地科考队在极夜期间驻扎在偏远的观测站，随着一名队员离奇失踪，剩下的成员开始互相猜疑。外界的通讯中断，暴风雪封锁了唯一的出路。负责补给调度的前警探不得不重新拾起旧日的直觉，在四十天的黑暗结束之前找出潜入队伍的陌生人。",
    actors: ["调度员 饰 凯尔", "医生 饰 艾琳", "站员 饰 麦克"],
    director: "Ethan Cole",
  },
  {
    id: "mv-005",
    title: "风起云涌",
    type: "电影",
    genre: ["动作", "战争", "剧情"],
    region: "中国大陆",
    year: 2022,
    updatedAt: "2022-06-30",
    episodes: "正片",
    rating: 8.0,
    heat: 8760,
    cover: "https://readdy.ai/api/search-image?query=Epic%20war%20drama%20movie%20poster%20of%20a%20determined%20commander%20on%20a%20cliff%20overlooking%20a%20valley%20of%20war%20smoke%2C%20fiery%20orange%20sunset%20backlight%2C%20dust%20and%20embers%2C%20cinematic%20historic%20aesthetic&width=400&height=600&seq=bale-mv-005&orientation=portrait",
    banner: "https://readdy.ai/api/search-image?query=Historic%20battlefield%20valley%20at%20golden%20sunset%20with%20drifting%20smoke%20and%20distant%20banners%2C%20warm%20orange%20sky%2C%20dark%20vignette%20for%20text%20overlay%2C%20cinematic%20epic%20wide%20shot&width=1600&height=900&seq=bale-bn-005&orientation=landscape",
    summary: "一支被遗忘的守军，用最后一座关隘挡住了一支十倍于己的军队。",
    description: "乱世将尽，天下大势已定，一座早已无人问津的关隘却仍旧驻守着一支残兵。当大军压境，年轻的守将被推上了本不属于他的位置。他要在粮草、援军与时间都耗尽的情况下，用一场注定要失败的坚守，为身后千千万万流离失所的人争取一个转身的机会。",
    actors: ["守将 饰 沈卓", "副将 饰 铁牛", "信使 饰 阿砚"],
    director: "郑远山",
  },
  {
    id: "mv-006",
    title: "春日告白信",
    type: "电影",
    genre: ["爱情", "剧情"],
    region: "韩国",
    year: 2024,
    updatedAt: "2024-04-16",
    episodes: "正片",
    rating: 8.1,
    heat: 7980,
    cover: "https://readdy.ai/api/search-image?query=Romantic%20drama%20poster%20of%20a%20young%20woman%20holding%20a%20bundle%20of%20handwritten%20letters%20under%20spring%20cherry%20blossoms%2C%20soft%20warm%20pastel%20light%2C%20dreamy%20bokeh%2C%20gentle%20nostalgic%20mood&width=400&height=600&seq=bale-mv-006&orientation=portrait",
    banner: "https://readdy.ai/api/search-image?query=Sunlit%20spring%20street%20lined%20with%20blooming%20cherry%20blossoms%2C%20soft%20warm%20pastel%20light%2C%20delicate%20petals%20drifting%2C%20breathing%20room%20for%20romantic%20headline%20text%2C%20cinematic%20dreamy%20tone&width=1600&height=900&seq=bale-bn-006&orientation=landscape",
    summary: "邮局的一角堆着一封从未寄出的信，而收信人每年春天都会来问一次。",
    description: "在老城区的邮局里，一位年轻职员偶然发现了一封被压在抽屉底层、迟迟未能投递的告白信。信的落款年份已是十年前，而收信人却每年春天都会准时出现，问一句“有没有我的信”。为了赶上对方最后一次来访，她决定亲手把这封信送到它该去的地方，也顺便解开了两个家庭之间一段无人知晓的往事。",
    actors: ["职员 饰 尹素拉", "收信人 饰 姜宇镇", "老人 饰 朴顺"],
    director: "金惠秀",
  },
  {
    id: "mv-007",
    title: "深海来客",
    type: "电影",
    genre: ["科幻", "惊悚", "悬疑"],
    region: "英国",
    year: 2023,
    updatedAt: "2023-12-05",
    episodes: "正片",
    rating: 7.7,
    heat: 7420,
    cover: "https://readdy.ai/api/search-image?query=Underwater%20sci-fi%20horror%20poster%20of%20a%20deep%20sea%20research%20submersible%20glowing%20in%20black%20ocean%20trench%2C%20bioluminescent%20particles%2C%20cold%20deep%20teal%20with%20warm%20submarine%20lights%2C%20eerie%20atmosphere&width=400&height=600&seq=bale-mv-007&orientation=portrait",
    banner: "https://readdy.ai/api/search-image?query=Deep%20ocean%20trench%20with%20bioluminescent%20glow%20and%20a%20tiny%20illuminated%20submersible%20descending%2C%20vast%20dark%20water%2C%20subtle%20warm%20light%20beams%20for%20text%20contrast%2C%20cinematic%20underwater%20scene&width=1600&height=900&seq=bale-bn-007&orientation=landscape",
    summary: "海沟六千米之下，声呐捕捉到了一段不属于任何已知生物的信号。",
    description: "一支国际深海考察队驾驶潜艇潜入未被勘探的海沟，试图寻找一种可能改写生物史的样本。随着下潜深度不断增加，声呐系统反复捕捉到一段有规律的信号，像是某种回应。当队员意识到那并非自然产生，返航的通道却已经被悄然关闭。",
    actors: ["队长 饰 艾米莉", "工程师 饰 卢卡", "生物学家 饰 诺亚"],
    director: "James Hale",
  },
  {
    id: "mv-008",
    title: "江湖再会",
    type: "电影",
    genre: ["动作", "冒险", "剧情"],
    region: "中国香港",
    year: 2021,
    updatedAt: "2021-09-11",
    episodes: "正片",
    rating: 7.8,
    heat: 6980,
    cover: "https://readdy.ai/api/search-image?query=Martial%20arts%20movie%20poster%20of%20a%20wandering%20swordsman%20standing%20in%20a%20misty%20bamboo%20forest%20at%20dawn%2C%20wind%20blown%20robe%2C%20warm%20golden%20mist%20backlight%2C%20ink%20wash%20aesthetic%2C%20cinematic%20tension&width=400&height=600&seq=bale-mv-008&orientation=portrait",
    banner: "https://readdy.ai/api/search-image?query=Misty%20dawn%20bamboo%20forest%20with%20golden%20backlight%20and%20drifting%20fog%2C%20lone%20traveler%20silhouette%20on%20a%20stone%20path%2C%20soft%20negative%20space%20for%20headline%20text%2C%20cinematic%20ink%20wash%20style&width=1600&height=900&seq=bale-bn-008&orientation=landscape",
    summary: "退隐十年的一把刀，因为一封请帖重新出鞘。",
    description: "十年前，江湖上最快的刀手在一场决斗后悄然消失。十年后，一封没有署名的请帖被送到他隐居的小镇，邀请他赴一场“最后的约会”。为了弄清当年那场决斗背后被掩埋的真相，他重新拿起刀，踏上了重返江湖的路。路遇故人、旧敌与新朋，他发现真正需要面对的并不是仇家，而是当年的自己。",
    actors: ["刀客 饰 秦默", "旧友 饰 阿九", "少年 饰 小豆"],
    director: "洪家骏",
  },
  {
    id: "mv-009",
    title: "深夜食堂物语",
    type: "电影",
    genre: ["剧情", "家庭"],
    region: "日本",
    year: 2022,
    updatedAt: "2022-03-22",
    episodes: "正片",
    rating: 8.3,
    heat: 7640,
    cover: "https://readdy.ai/api/search-image?query=Cozy%20Japanese%20food%20drama%20poster%20of%20a%20tiny%20late%20night%20eatery%20with%20warm%20lantern%20glow%2C%20steaming%20bowl%20on%20a%20wooden%20counter%2C%20intimate%20warm%20amber%20light%2C%20gentle%20nostalgic%20mood&width=400&height=600&seq=bale-mv-009&orientation=portrait",
    banner: "https://readdy.ai/api/search-image?query=Narrow%20Japanese%20alley%20at%20night%20with%20glowing%20shop%20lanterns%20and%20a%20small%20eatery%20door%20open%2C%20warm%20amber%20light%20spilling%20out%2C%20gentle%20bokeh%2C%20cozy%20cinematic%20mood%20for%20text&width=1600&height=900&seq=bale-bn-009&orientation=landscape",
    summary: "凌晨十二点开门的小店，只做一道菜，却装下了整条街的心事。",
    description: "在城市最不起眼的一条巷子里，有一家只在午夜开门的小食堂。老板不多话，只问一句“今天想吃什么”。出租车司机、便利店店员、离家出走的少年，形形色色的客人在这一方小桌前卸下伪装。每一道家常菜背后，都是一段平凡却动人的故事。",
    actors: ["老板 饰 佐藤健一", "常客 饰 小林优子", "少年 饰 山田凉"],
    director: "森川遥",
  },
  {
    id: "mv-010",
    title: "逆转时空",
    type: "电影",
    genre: ["科幻", "悬疑", "剧情"],
    region: "美国",
    year: 2024,
    updatedAt: "2024-07-08",
    episodes: "正片",
    rating: 8.6,
    heat: 9310,
    cover: "https://readdy.ai/api/search-image?query=Mind%20bending%20sci-fi%20poster%20of%20a%20man%20standing%20between%20reflected%20mirror%20versions%20of%20a%20city%2C%20fractured%20glass%20effect%2C%20warm%20orange%20and%20cool%20slate%20contrast%2C%20surreal%20cinematic%20composition&width=400&height=600&seq=bale-mv-010&orientation=portrait",
    banner: "https://readdy.ai/api/search-image?query=Surreal%20city%20skyline%20fractured%20into%20mirror%20reflections%20with%20a%20lone%20figure%20at%20the%20center%2C%20warm%20orange%20glow%20and%20cool%20shadows%2C%20dark%20edges%20for%20text%20overlay%2C%20cinematic%20sci-fi%20key%20art&width=1600&height=900&seq=bale-bn-010&orientation=landscape",
    summary: "每次回到过去，他都会失去一段记忆，而这一次他忘了自己为什么要回来。",
    description: "物理学家在一次实验中意外获得了回到过去五分钟的能力，却发现每次回溯都会抹去自己的一段记忆。为了阻止一场即将发生的灾难，他一遍遍地回到原点，也在一次次遗忘中逐渐失去自我。当他在最后关头终于回到起点，却发现自己已经不记得最初想要拯救的人是谁。",
    actors: ["物理学家 饰 丹尼尔", "同事 饰 索菲亚", "女儿 饰 莉莉"],
    director: "Marcus Reed",
  },
  {
    id: "mv-011",
    title: "山那边的光",
    type: "电影",
    genre: ["剧情", "家庭"],
    region: "中国大陆",
    year: 2025,
    updatedAt: "2025-08-21",
    episodes: "正片",
    rating: 8.5,
    heat: 8210,
    cover: "https://readdy.ai/api/search-image?query=Warm%20rural%20family%20drama%20poster%20of%20a%20teacher%20and%20children%20on%20a%20mountain%20path%20at%20sunset%2C%20golden%20backlight%2C%20gentle%20dust%20in%20the%20air%2C%20hopeful%20warm%20palette%2C%20cinematic%20realism&width=400&height=600&seq=bale-mv-011&orientation=portrait",
    banner: "https://readdy.ai/api/search-image?query=Golden%20sunset%20over%20rolling%20mountain%20village%20with%20a%20winding%20path%20and%20small%20school%20building%2C%20warm%20hopeful%20light%2C%20soft%20haze%20for%20text%20overlay%2C%20cinematic%20wide%20shot&width=1600&height=900&seq=bale-bn-011&orientation=landscape",
    summary: "一位年轻教师来到大山深处，才发现自己才是那个被照亮的人。",
    description: "刚从师范毕业的年轻人怀揣理想来到大山深处的一所小学任教，却被简陋的条件和只有七个学生的教室浇了一盆冷水。在与孩子们日复一日的相处中，他渐渐明白，教育不只是把知识带进山里，更是让山里的光被看见。当一次意外的机会摆在面前，他必须做出留在山里还是回到城市的选择。",
    actors: ["教师 饰 顾青", "学生 饰 小满", "校长 饰 老周"],
    director: "苏牧",
  },
  {
    id: "mv-012",
    title: "王牌特勤",
    type: "电影",
    genre: ["动作", "犯罪", "冒险"],
    region: "美国",
    year: 2023,
    updatedAt: "2023-05-27",
    episodes: "正片",
    rating: 7.6,
    heat: 7860,
    cover: "https://readdy.ai/api/search-image?query=Action%20spy%20movie%20poster%20of%20an%20agent%20in%20a%20sharply%20tailored%20suit%20against%20a%20blurred%20city%20night%20skyline%2C%20neon%20warm%20accents%2C%20dynamic%20angle%2C%20sleek%20cinematic%20gloss&width=400&height=600&seq=bale-mv-012&orientation=portrait",
    banner: "https://readdy.ai/api/search-image?query=Glossy%20night%20city%20skyline%20with%20motion%20blurred%20lights%20and%20a%20silhouetted%20agent%20on%20a%20rooftop%2C%20warm%20amber%20highlights%20and%20dark%20shadows%2C%20space%20for%20action%20headline%20text&width=1600&height=900&seq=bale-bn-012&orientation=landscape",
    summary: "被停职的王牌特工，只能靠一支临时拼凑的小队阻止一场跨国阴谋。",
    description: "因为一次行动失误，特勤局最优秀的特工被停职调查。就在此时，一份加密情报显示有组织正策划在金融峰会上发动袭击。得不到正式支援的他，只能召集几位同样被边缘化的老同事，组成一支临时小队潜入会场。时间以分钟计算，每个人都必须拿出自己最不擅长的一面。",
    actors: ["特工 饰 杰克", "黑客 饰 米娅", "老搭档 饰 汉森"],
    director: "Ryan Brooks",
  },
  {
    id: "mv-013",
    title: "童话镇奇遇",
    type: "电影",
    genre: ["奇幻", "冒险", "家庭"],
    region: "英国",
    year: 2024,
    updatedAt: "2024-12-24",
    episodes: "正片",
    rating: 8.0,
    heat: 7120,
    cover: "https://readdy.ai/api/search-image?query=Whimsical%20fantasy%20family%20poster%20of%20a%20child%20opening%20a%20glowing%20storybook%20with%20tiny%20floating%20lights%2C%20warm%20golden%20magic%20glow%2C%20cozy%20enchanting%20atmosphere%2C%20storybook%20illustration%20style&width=400&height=600&seq=bale-mv-013&orientation=portrait",
    banner: "https://readdy.ai/api/search-image?query=Enchanted%20storybook%20village%20at%20twilight%20with%20glowing%20windows%20and%20floating%20lanterns%2C%20warm%20golden%20magical%20haze%2C%20dark%20sky%20edges%20for%20title%20text%2C%20whimsical%20cinematic%20scene&width=1600&height=900&seq=bale-bn-013&orientation=landscape",
    summary: "当童话书里的世界开始褪色，只有真正的读者才能把它重新点亮。",
    description: "十岁的小女孩在祖母的旧书屋里发现了一本会发光的童话书，翻开后竟被吸入了故事世界。可这里的一切都在慢慢褪色——因为很久没有人认真读过这些故事了。为了让童话镇恢复颜色，她必须和书中结识的伙伴一起，赶在最后一页翻完之前找回散落各地的“故事之火”。",
    actors: ["艾拉 饰 小读者", "狐狸 饰 引路人", "守书人 饰 老汤姆"],
    director: "Oliver Grant",
  },
  {
    id: "mv-014",
    title: "血色黎明",
    type: "电影",
    genre: ["战争", "历史", "剧情"],
    region: "中国大陆",
    year: 2021,
    updatedAt: "2021-11-30",
    episodes: "正片",
    rating: 7.9,
    heat: 6680,
    cover: "https://readdy.ai/api/search-image?query=Gritty%20historical%20war%20poster%20of%20soldiers%20advancing%20through%20dawn%20fog%20on%20a%20ridge%2C%20warm%20orange%20sunrise%20against%20cold%20grey%20smoke%2C%20dust%20and%20embers%2C%20cinematic%20realism&width=400&height=600&seq=bale-mv-014&orientation=portrait",
    banner: "https://readdy.ai/api/search-image?query=Advancing%20soldiers%20silhouettes%20through%20dawn%20fog%20on%20a%20ridge%20with%20warm%20orange%20sunrise%20breaking%20over%20grey%20smoke%2C%20epic%20cinematic%20war%20landscape%20with%20text%20space&width=1600&height=900&seq=bale-bn-014&orientation=landscape",
    summary: "黎明之前的那两个小时，决定了一整座城的命运。",
    description: "一场决定战局的关键战役打响在黎明前最黑暗的两个小时。一支侦察小队必须在主力发起进攻之前，穿过敌方封锁的河谷，摸清火力部署。他们中有刚入伍的新兵，也有打过无数硬仗的老兵。当第一缕晨光越过山脊，他们知道，无论结果如何，这座城的天就要亮了。",
    actors: ["队长 饰 韩铮", "新兵 饰 小石头", "向导 饰 老李"],
    director: "冯建军",
  },
  {
    id: "mv-015",
    title: "恋爱频道",
    type: "电影",
    genre: ["喜剧", "爱情"],
    region: "韩国",
    year: 2025,
    updatedAt: "2025-06-14",
    episodes: "正片",
    rating: 7.5,
    heat: 7340,
    cover: "https://readdy.ai/api/search-image?query=Playful%20romantic%20comedy%20poster%20of%20two%20people%20back%20to%20back%20with%20colorful%20camera%20and%20microphone%20props%2C%20bright%20warm%20pastel%20background%2C%20cheerful%20fun%20mood&width=400&height=600&seq=bale-mv-015&orientation=portrait",
    banner: "https://readdy.ai/api/search-image?query=Bright%20colorful%20television%20studio%20set%20with%20warm%20pastel%20lights%20and%20camera%20equipment%2C%20cheerful%20playful%20atmosphere%2C%20soft%20focus%20for%20title%20text%2C%20cinematic%20warm%20tone&width=1600&height=900&seq=bale-bn-015&orientation=landscape",
    summary: "一个过气的恋爱综艺导演，和一个专拆台的健康节目主持人，被逼着一起做一档新节目。",
    description: "曾经红极一时的恋爱综艺导演如今面临节目被砍的危机，台里却偏偏安排他和一位以毒舌著称的健康节目主持人搭档。两人理念南辕北辙，从第一期录制就针锋相对。可当节目意外爆红，广告商纷至沓来，他们才发现，观众爱看的恰恰是镜头外那点说不清道不明的东西。",
    actors: ["导演 饰 崔成宇", "主持人 饰 李智恩", "台长 饰 朴部长"],
    director: "郑在勋",
  },
  {
    id: "mv-016",
    title: "迷雾档案",
    type: "电影",
    genre: ["悬疑", "犯罪", "惊悚"],
    region: "美国",
    year: 2022,
    updatedAt: "2022-10-19",
    episodes: "正片",
    rating: 7.8,
    heat: 7020,
    cover: "https://readdy.ai/api/search-image?query=Noir%20mystery%20poster%20of%20a%20detective%20silhouette%20in%20a%20fog%20filled%20street%20lit%20by%20a%20single%20warm%20streetlamp%2C%20cold%20blue%20grey%20fog%2C%20high%20contrast%20cinematic%20noir%20lighting&width=400&height=600&seq=bale-mv-016&orientation=portrait",
    banner: "https://readdy.ai/api/search-image?query=Fog%20filled%20city%20street%20at%20night%20glowing%20under%20warm%20streetlamps%2C%20cold%20grey%20mist%20hiding%20the%20distance%2C%20moody%20noir%20cinematic%20atmosphere%20with%20space%20for%20text&width=1600&height=900&seq=bale-bn-016&orientation=landscape",
    summary: "一份编号被抹去的旧档案，牵出警局内部二十年的秘密。",
    description: "档案管理员在整理旧卷宗时，发现了一份编号被人为抹去的案件档案。随着他一点点还原文件内容，一个涉及警局内部、横跨二十年的秘密逐渐浮出水面。当调查的矛头指向现任高层，他必须在保全自己和还死者一个公道之间做出选择。",
    actors: ["档案员 饰 亚瑟", "记者 饰 克莱尔", "警监 饰 沃德"],
    director: "Sarah Nolan",
  },
  {
    id: "tv-001",
    title: "京华烟云录",
    type: "电视剧",
    genre: ["剧情", "历史", "家庭"],
    region: "中国大陆",
    year: 2025,
    updatedAt: "2025-10-11",
    episodes: "更新至36集",
    rating: 8.8,
    heat: 9930,
    cover: "https://readdy.ai/api/search-image?query=Chinese%20period%20drama%20poster%20of%20an%20elegant%20woman%20in%20a%20traditional%20cheongsam%20standing%20in%20a%20grand%20old%20courtyard%2C%20warm%20amber%20lantern%20light%2C%20rich%20historical%20texture%2C%20cinematic%20elegance&width=400&height=600&seq=bale-tv-001&orientation=portrait",
    banner: "https://readdy.ai/api/search-image?query=Grand%20traditional%20Chinese%20courtyard%20at%20dusk%20with%20warm%20lanterns%20and%20red%20wood%20architecture%2C%20misty%20depth%2C%20dark%20gradient%20for%20title%20text%2C%20cinematic%20period%20drama%20key%20art&width=1600&height=900&seq=bale-bn-101&orientation=landscape",
    summary: "一座宅院的兴衰，三代女性的命运，串起半个世纪的风云变幻。",
    description: "故事从民国初年的一座老宅说起。掌家的女主人要在时代巨变中守住祖业，她的女儿渴望走出深宅去看看外面的世界，而最小的孙女则在战火中长大。三代女性各自面对不同的困境，却都用自己的方式在动荡里寻找立足之地。剧集以细腻的笔触描绘家族兴衰，也描摹了一个时代的侧影。",
    actors: ["苏婉 饰 沈知瑶", "林砚 饰 苏念", "程越 饰 顾怀安"],
    director: "孔祥瑞",
  },
  {
    id: "tv-002",
    title: "都市浮生记",
    type: "电视剧",
    genre: ["剧情", "爱情"],
    region: "中国大陆",
    year: 2024,
    updatedAt: "2024-09-05",
    episodes: "全40集",
    rating: 8.0,
    heat: 8850,
    cover: "https://readdy.ai/api/search-image?query=Urban%20drama%20poster%20of%20young%20professionals%20walking%20through%20a%20glowing%20city%20street%20at%20dusk%2C%20warm%20window%20lights%2C%20soft%20rain%20reflections%2C%20modern%20cinematic%20warm%20tone&width=400&height=600&seq=bale-tv-002&orientation=portrait",
    banner: "https://readdy.ai/api/search-image?query=Modern%20city%20street%20at%20dusk%20with%20warm%20window%20lights%20and%20soft%20rain%20reflections%20on%20the%20ground%2C%20gentle%20bokeh%2C%20space%20for%20drama%20title%20text%2C%20cinematic%20warm%20palette&width=1600&height=900&seq=bale-bn-102&orientation=landscape",
    summary: "四个合租在同一屋檐下的年轻人，在城市里跌跌撞撞地寻找自己的位置。",
    description: "四个背景迥异的年轻人因为一场租房乌龙住进了同一间公寓。有人踌躇满志却屡屡碰壁，有人看似洒脱实则背负着家庭的重担，也有人只想安安稳稳地过完每一天。他们在加班的深夜互相留一盏灯，在失意的清晨一起去楼下吃一碗热面。剧集用温暖而真实的笔触，讲述一代人在城市中相互搀扶着长大的故事。",
    actors: ["陆沉 饰 江川", "许清 饰 林晓", "周睿 饰 陈默"],
    director: "李思远",
  },
  {
    id: "tv-003",
    title: "暗流",
    type: "电视剧",
    genre: ["悬疑", "犯罪", "剧情"],
    region: "中国大陆",
    year: 2025,
    updatedAt: "2025-10-08",
    episodes: "更新至24集",
    rating: 8.6,
    heat: 9540,
    cover: "https://readdy.ai/api/search-image?query=Crime%20series%20poster%20of%20a%20harbor%20city%20at%20night%20with%20dim%20warehouse%20lights%20and%20a%20lone%20figure%20on%20the%20pier%2C%20cold%20slate%20water%20with%20warm%20accent%20glow%2C%20tense%20cinematic%20mood&width=400&height=600&seq=bale-tv-003&orientation=portrait",
    banner: "https://readdy.ai/api/search-image?query=Industrial%20harbor%20at%20night%20with%20dim%20warehouse%20lights%20reflecting%20on%20dark%20water%2C%20cranes%20silhouetted%20against%20a%20deep%20sky%2C%20moody%20cinematic%20space%20for%20crime%20title%20text&width=1600&height=900&seq=bale-bn-103&orientation=landscape",
    summary: "一桩看似普通的失踪案，撕开了港口城市水下盘根错节的利益网。",
    description: "滨海小城接连发生几起看似无关的案件，负责调查的刑警队长隐约察觉到背后有一条看不见的暗流。顺着线索往下查，一张横跨走私、洗钱与地方势力的关系网逐渐浮现，而网的中心竟然牵涉到多年前的一桩旧案。为了把真相挖出来，他必须步步为营，也要付出代价。",
    actors: ["刑警 饰 高远", "检察官 饰 沈亦", "线人 饰 阿海"],
    director: "王砚舟",
  },
  {
    id: "tv-004",
    title: "办公室风云",
    type: "电视剧",
    genre: ["喜剧", "剧情"],
    region: "韩国",
    year: 2023,
    updatedAt: "2023-07-14",
    episodes: "全16集",
    rating: 8.1,
    heat: 7920,
    cover: "https://readdy.ai/api/search-image?query=Workplace%20comedy%20poster%20of%20office%20workers%20in%20a%20colorful%20modern%20office%20with%20coffee%20cups%20and%20sticky%20notes%2C%20bright%20warm%20daylight%2C%20playful%20energetic%20mood&width=400&height=600&seq=bale-tv-004&orientation=portrait",
    banner: "https://readdy.ai/api/search-image?query=Bright%20modern%20open%20plan%20office%20with%20warm%20sunlight%20and%20neat%20desks%20and%20plants%2C%20cheerful%20clean%20atmosphere%2C%20soft%20space%20for%20comedy%20title%20text&width=1600&height=900&seq=bale-bn-104&orientation=landscape",
    summary: "一家年年亏损却从不倒闭的部门，和一群每天都想辞职又舍不得的同事。",
    description: "在一家大公司的角落里，有一个年年被通报批评却始终没有撤销的部门。这里有只会甩锅的上司、什么都会就是不会说“不”的老员工、刚入职满是理想的新人，还有那个总在关键时刻救场却从不邀功的行政。他们每天为了一点小事鸡飞狗跳，也在每一次危机来临时默契地拧成一股绳。",
    actors: ["组长 饰 金东旭", "行政 饰 韩智雅", "新人 饰 李泰民"],
    director: "朴成勋",
  },
  {
    id: "tv-005",
    title: "星辰大海",
    type: "电视剧",
    genre: ["科幻", "冒险", "剧情"],
    region: "美国",
    year: 2024,
    updatedAt: "2024-11-20",
    episodes: "全12集",
    rating: 8.5,
    heat: 9020,
    cover: "https://readdy.ai/api/search-image?query=Space%20opera%20series%20poster%20of%20a%20crew%20silhouetted%20before%20a%20vast%20glowing%20planet%20window%2C%20warm%20orange%20nebula%20and%20deep%20space%20darkness%2C%20epic%20cinematic%20composition&width=400&height=600&seq=bale-tv-005&orientation=portrait",
    banner: "https://readdy.ai/api/search-image?query=Vast%20space%20view%20from%20a%20starship%20window%20with%20a%20glowing%20orange%20nebula%20and%20distant%20stars%2C%20dark%20silhouetted%20controls%20in%20foreground%2C%20cinematic%20sci-fi%20title%20space&width=1600&height=900&seq=bale-bn-105&orientation=landscape",
    summary: "一艘殖民舰驶向新家园，而船上的人要在抵达之前，先学会共存。",
    description: "人类首批星际殖民舰之一“星辰号”载着数千名船员与移民，踏上前往新家园的漫长旅程。航程中，资源分配、代际更替与信念分歧不断引发矛盾，飞船本身也频频出现故障。舰长和他的团队必须在封闭的船舱里维系秩序，也在一次次抉择中追问：我们究竟是为了逃离过去，还是为了抵达未来。",
    actors: ["舰长 饰 艾莉森", "工程师 饰 卡尔", "医生 饰 娜奥米"],
    director: "Greg Lawson",
  },
  {
    id: "tv-006",
    title: "医者仁心",
    type: "电视剧",
    genre: ["剧情", "家庭"],
    region: "中国大陆",
    year: 2022,
    updatedAt: "2022-05-18",
    episodes: "全36集",
    rating: 8.3,
    heat: 8140,
    cover: "https://readdy.ai/api/search-image?query=Medical%20drama%20poster%20of%20a%20dedicated%20doctor%20in%20a%20bright%20hospital%20corridor%20with%20warm%20morning%20light%2C%20calm%20hopeful%20tone%2C%20clean%20cinematic%20realism&width=400&height=600&seq=bale-tv-006&orientation=portrait",
    banner: "https://readdy.ai/api/search-image?query=Bright%20hospital%20corridor%20flooded%20with%20warm%20morning%20light%20through%20tall%20windows%2C%20clean%20calm%20atmosphere%2C%20soft%20focus%20for%20drama%20title%20text%2C%20cinematic%20realism&width=1600&height=900&seq=bale-bn-106&orientation=landscape",
    summary: "在急诊室的每一分钟里，医生和病人都在学着如何面对生命。",
    description: "故事围绕一家三甲医院急诊科展开。年轻的住院医师在高强度的临床一线快速成长，资深的主治医生一边抢救病人一边要面对家庭的亏欠，而护士长则在日复一日的琐碎中撑起整个科室的秩序。每一个病例背后都是一个家庭，每一次抉择都不只是在治病，更是在面对人心。",
    actors: ["住院医 饰 周叙", "主治 饰 沈岱", "护士长 饰 何静"],
    director: "林知秋",
  },
  {
    id: "tv-007",
    title: "权谋天下",
    type: "电视剧",
    genre: ["历史", "战争", "剧情"],
    region: "中国大陆",
    year: 2023,
    updatedAt: "2023-03-09",
    episodes: "全45集",
    rating: 8.4,
    heat: 8460,
    cover: "https://readdy.ai/api/search-image?query=Historical%20epic%20poster%20of%20a%20towering%20palace%20hall%20with%20warm%20candlelight%20and%20a%20lone%20figure%20in%20ceremonial%20robes%2C%20rich%20amber%20and%20deep%20shadow%2C%20cinematic%20grandeur&width=400&height=600&seq=bale-tv-007&orientation=portrait",
    banner: "https://readdy.ai/api/search-image?query=Vast%20ancient%20palace%20courtyard%20at%20night%20lit%20by%20rows%20of%20warm%20torches%2C%20dramatic%20long%20shadows%2C%20deep%20perspective%20with%20space%20for%20epic%20title%20text%2C%20cinematic%20grandeur&width=1600&height=900&seq=bale-bn-107&orientation=landscape",
    summary: "庙堂之上，一句话可以定生死；庙堂之外，一个人要走过多少路才能回到故乡。",
    description: "在一次朝堂变故之后，一位出身寒门的年轻谋士被卷入了权力中心。他要在各方势力之间小心行走，既要保全自身的信念，也要为身后那些无声无息的人争取一线生机。随着局势不断变化，他发现真正难的不是赢得一场争斗，而是在权力之中守住出发时的自己。",
    actors: ["谋士 饰 谢知白", "将军 饰 霍青山", "太后 饰 明氏"],
    director: "高文远",
  },
  {
    id: "tv-008",
    title: "东京物语新篇",
    type: "电视剧",
    genre: ["家庭", "剧情"],
    region: "日本",
    year: 2024,
    updatedAt: "2024-02-27",
    episodes: "全10集",
    rating: 8.2,
    heat: 7480,
    cover: "https://readdy.ai/api/search-image?query=Gentle%20family%20drama%20poster%20of%20an%20elderly%20couple%20on%20a%20quiet%20tokyo%20street%20at%20golden%20hour%2C%20warm%20soft%20light%2C%20nostalgic%20tender%20mood%2C%20cinematic%20realism&width=400&height=600&seq=bale-tv-008&orientation=portrait",
    banner: "https://readdy.ai/api/search-image?query=Quiet%20tokyo%20residential%20street%20at%20golden%20hour%20with%20low%20houses%20and%20warm%20window%20light%2C%20gentle%20nostalgic%20atmosphere%2C%20soft%20space%20for%20drama%20title%20text&width=1600&height=900&seq=bale-bn-108&orientation=landscape",
    summary: "一对老人第一次去大城市看望各自的儿女，却发现彼此都成了客人。",
    description: "住在乡下的一对老夫妻决定去大城市看望多年未见的儿女。可当他们真正走进儿女的生活，才发现每个人都忙得没有时间好好说一句话。老两口在城市的高楼之间默默走了一圈，带着理解也带着失落踏上归途。剧集用平静克制的镜头，讲述关于亲情、距离与时间的恒久命题。",
    actors: ["父亲 饰 平山周吉", "母亲 饰 平山富子", "长女 饰 平山绫"],
    director: "小林和也",
  },
  {
    id: "tv-009",
    title: "边境线",
    type: "电视剧",
    genre: ["动作", "犯罪", "剧情"],
    region: "美国",
    year: 2025,
    updatedAt: "2025-10-05",
    episodes: "更新至18集",
    rating: 8.3,
    heat: 9150,
    cover: "https://readdy.ai/api/search-image?query=Action%20crime%20series%20poster%20of%20a%20rugged%20border%20landscape%20at%20dusk%20with%20a%20lone%20patrol%20vehicle%2C%20warm%20orange%20sky%20against%20dark%20desert%2C%20gritty%20cinematic%20realism&width=400&height=600&seq=bale-tv-009&orientation=portrait",
    banner: "https://readdy.ai/api/search-image?query=Rugged%20desert%20border%20landscape%20at%20dusk%20with%20a%20winding%20road%20and%20fence%20line%2C%20warm%20orange%20sky%20and%20deep%20shadows%2C%20gritty%20cinematic%20space%20for%20series%20title%20text&width=1600&height=900&seq=bale-bn-109&orientation=landscape",
    summary: "在一条漫长而寂寞的边境线上，巡逻队要面对的不只是越境者，还有人心的边界。",
    description: "故事发生在一段绵延数百公里的边境地带。一支人手不足的巡逻队每天要应对走私、偷渡与突如其来的冲突，队员之间也各怀心事。新任队长试图用更人性化的方式处理每一次任务，却不断被现实推着做出艰难的取舍。剧集在紧张的单元事件中，缓缓铺开每个人身后的故事。",
    actors: ["队长 饰 雷耶斯", "副手 饰 丹尼", "医师 饰 玛雅"],
    director: "Chris Dalton",
  },
  {
    id: "tv-010",
    title: "青春纪事",
    type: "电视剧",
    genre: ["青春", "爱情", "剧情"],
    region: "中国大陆",
    year: 2023,
    updatedAt: "2023-09-26",
    episodes: "全24集",
    rating: 8.0,
    heat: 7680,
    cover: "https://readdy.ai/api/search-image?query=Youth%20drama%20poster%20of%20high%20school%20students%20cycling%20along%20a%20tree%20lined%20path%20in%20late%20afternoon%20sunlight%2C%20bright%20warm%20nostalgic%20tone%2C%20cheerful%20cinematic%20mood&width=400&height=600&seq=bale-tv-010&orientation=portrait",
    banner: "https://readdy.ai/api/search-image?query=Sunlit%20tree%20lined%20school%20path%20in%20late%20afternoon%20with%20dappled%20shadows%20and%20flying%20leaves%2C%20bright%20warm%20nostalgic%20atmosphere%2C%20space%20for%20youth%20title%20text&width=1600&height=900&seq=bale-bn-110&orientation=landscape",
    summary: "高三那一年，他们一边倒数着高考，一边偷偷收藏着整个青春。",
    description: "故事发生在一所普通高中的高三班级里。有人在题海里埋头苦读，有人在偷偷喜欢着同桌，也有人已经开始为未来做别的打算。教室、走廊、操场和晚自习后的路灯，见证了他们所有的笨拙与勇敢。多年以后回头看，那一年最珍贵的不是分数，而是一起熬过那段日子的人。",
    actors: ["夏树 饰 沈一诺", "江逾 饰 顾言", "苏晴 饰 林小满"],
    director: "温子谦",
  },
  {
    id: "tv-011",
    title: "豪门恩怨",
    type: "电视剧",
    genre: ["剧情", "爱情", "家庭"],
    region: "韩国",
    year: 2022,
    updatedAt: "2022-12-13",
    episodes: "全20集",
    rating: 7.7,
    heat: 7060,
    cover: "https://readdy.ai/api/search-image?query=Elegant%20family%20melodrama%20poster%20of%20a%20luxurious%20mansion%20staircase%20with%20warm%20chandelier%20light%20and%20a%20woman%20in%20an%20evening%20gown%2C%20rich%20amber%20and%20deep%20shadow&width=400&height=600&seq=bale-tv-011&orientation=portrait",
    banner: "https://readdy.ai/api/search-image?query=Luxurious%20mansion%20hall%20with%20a%20grand%20staircase%20and%20glowing%20chandeliers%2C%20warm%20amber%20light%20and%20deep%20shadows%2C%20elegant%20cinematic%20space%20for%20melodrama%20title%20text&width=1600&height=900&seq=bale-bn-111&orientation=landscape",
    summary: "一场遗产争夺，让表面和睦的家族把所有秘密都摆到了台面上。",
    description: "家族企业的老会长突然去世，一份出人意料的遗嘱让原本平静的豪门掀起波澜。长女想守住家业，次子志在改革，而那位从未被家族承认的私生子也带着自己的坚持回到了这里。在觥筹交错与暗中角力之间，每个人都在为自己的选择付出代价，也在波折中重新理解了“家”的含义。",
    actors: ["长女 饰 徐珍雅", "次子 饰 徐俊浩", "理事 饰 车敏"],
    director: "宋在熙",
  },
  {
    id: "tv-012",
    title: "魔法学院",
    type: "电视剧",
    genre: ["奇幻", "冒险", "青春"],
    region: "英国",
    year: 2024,
    updatedAt: "2024-08-30",
    episodes: "全8集",
    rating: 8.1,
    heat: 7760,
    cover: "https://readdy.ai/api/search-image?query=Fantasy%20series%20poster%20of%20a%20grand%20gothic%20magic%20academy%20under%20a%20golden%20sky%20with%20floating%20candles%2C%20warm%20magical%20glow%20against%20deep%20shadows%2C%20enchanting%20cinematic%20mood&width=400&height=600&seq=bale-tv-012&orientation=portrait",
    banner: "https://readdy.ai/api/search-image?query=Grand%20gothic%20magic%20academy%20campus%20at%20dusk%20with%20glowing%20windows%20and%20floating%20lanterns%2C%20warm%20golden%20magical%20haze%2C%20deep%20sky%20for%20title%20text%2C%20cinematic%20fantasy%20scene&width=1600&height=900&seq=bale-bn-112&orientation=landscape",
    summary: "一群初入魔法学院的新生，要用一整年去证明：天赋并不是唯一的答案。",
    description: "在一所历史悠久的魔法学院里，每年都会迎来一批天赋各异的新生。有人天生魔力充沛，有人却连最基础的咒语都要反复练习。他们被分进各自不同的学院，在竞争与合作中学习、犯错、和解。当学院深处一扇被封印多年的门出现异动，这群看似普通的新生反而成了唯一能够应对的人。",
    actors: ["新生 饰 艾拉", "学长 饰 芬恩", "导师 饰 玛格丽特"],
    director: "Henry Walsh",
  },
  {
    id: "an-001",
    title: "剑与远方",
    type: "动漫",
    genre: ["冒险", "奇幻", "剧情"],
    region: "日本",
    year: 2025,
    updatedAt: "2025-10-10",
    episodes: "更新至22集",
    rating: 8.9,
    heat: 9760,
    cover: "https://readdy.ai/api/search-image?query=Anime%20adventure%20poster%20of%20a%20young%20swordsman%20standing%20on%20a%20cliff%20looking%20toward%20distant%20mountains%20at%20sunrise%2C%20warm%20golden%20sky%2C%20wind%20blown%20cloak%2C%20painterly%20anime%20style&width=400&height=600&seq=bale-an-001&orientation=portrait",
    banner: "https://readdy.ai/api/search-image?query=Sweeping%20anime%20landscape%20of%20sunrise%20over%20distant%20mountains%20and%20a%20winding%20road%20with%20a%20small%20traveler%20figure%2C%20warm%20golden%20sky%2C%20painterly%20anime%20art%20with%20title%20space&width=1600&height=900&seq=bale-bn-201&orientation=landscape",
    summary: "少年背着一把不是自己的剑，踏上了寻找故乡的旅途。",
    description: "在一个剑与魔法并存的大陆上，少年背负着一把来历不明的旧剑，从边境小镇出发，去寻找自己早已记不清的故乡。旅途中他遇见了形形色色的同伴：失去记忆的少女法师、话虽多却可靠的佣兵、以及一只总在关键时刻闯祸的旅鸟。他们一路走过城镇、荒野与古老的遗迹，也在一次次并肩作战中逐渐拼出各自的过去。",
    actors: ["少年 饰 凯", "少女 饰 露娜", "佣兵 饰 巴洛"],
    director: "新海诚一",
  },
  {
    id: "an-002",
    title: "机甲纪元",
    type: "动漫",
    genre: ["科幻", "动作", "冒险"],
    region: "日本",
    year: 2024,
    updatedAt: "2024-06-18",
    episodes: "全24集",
    rating: 8.6,
    heat: 9340,
    cover: "https://readdy.ai/api/search-image?query=Mecha%20anime%20poster%20of%20a%20towering%20humanoid%20robot%20standing%20in%20a%20ruined%20future%20city%20at%20dusk%2C%20warm%20orange%20glow%20and%20cool%20metal%20shadows%2C%20dynamic%20dramatic%20composition&width=400&height=600&seq=bale-an-002&orientation=portrait",
    banner: "https://readdy.ai/api/search-image?query=Giant%20humanoid%20mecha%20silhouette%20against%20a%20burning%20orange%20dusk%20sky%20in%20a%20ruined%20future%20city%2C%20dramatic%20scale%2C%20cinematic%20anime%20key%20art%20with%20title%20space&width=1600&height=900&seq=bale-bn-202&orientation=landscape",
    summary: "人类最后的防线，是一群还没长大的孩子和他们亲手驾驶的机甲。",
    description: "地球在连年的侵袭中满目疮痍，人类赖以生存的最后几座要塞不断缩小。为了对抗不断进化的敌人，军方不得不提前启用一批尚未成年的驾驶员。他们在严苛的训练中被迫迅速长大，也在一次次惨烈的战斗里学会了信任彼此。当最强的一波攻势来临，这群少年必须用自己的方式守住最后的天空。",
    actors: ["驾驶员 饰 凉太", "队长 饰 真希", "技师 饰 阿拓"],
    director: "川口雄大",
  },
  {
    id: "an-003",
    title: "校园日常",
    type: "动漫",
    genre: ["喜剧", "青春", "日常"],
    region: "日本",
    year: 2023,
    updatedAt: "2023-04-08",
    episodes: "全12集",
    rating: 8.2,
    heat: 7420,
    cover: "https://readdy.ai/api/search-image?query=Slice%20of%20life%20anime%20poster%20of%20cheerful%20students%20in%20a%20sunny%20classroom%20with%20open%20windows%20and%20flying%20curtains%2C%20bright%20warm%20pastel%20tone%2C%20playful%20anime%20style&width=400&height=600&seq=bale-an-003&orientation=portrait",
    banner: "https://readdy.ai/api/search-image?query=Sunny%20high%20school%20classroom%20with%20open%20windows%20and%20fluttering%20curtains%2C%20bright%20warm%20afternoon%20light%2C%20cheerful%20slice%20of%20life%20anime%20atmosphere%20with%20title%20space&width=1600&height=900&seq=bale-bn-203&orientation=landscape",
    summary: "没有什么惊天动地的大事，但每一天都值得被认真记住。",
    description: "故事围绕一群普通高中生展开，没有拯救世界，也没有跌宕起伏的剧情。他们为了谁先把午饭吃完而打赌，为了文化祭的节目吵得不可开交，也会在放学后的天台上聊一些自以为很深刻的话题。正是这些看似无意义的日常，构成了青春里最柔软的部分。",
    actors: ["班长 饰 小春", "吃货 饰 大辅", "转学生 饰 美咲"],
    director: "山本和真",
  },
  {
    id: "an-004",
    title: "神域幻想",
    type: "动漫",
    genre: ["奇幻", "冒险", "动作"],
    region: "日本",
    year: 2025,
    updatedAt: "2025-09-30",
    episodes: "更新至18集",
    rating: 8.5,
    heat: 9210,
    cover: "https://readdy.ai/api/search-image?query=Epic%20fantasy%20anime%20poster%20of%20a%20hero%20surrounded%20by%20glowing%20runic%20magic%20circles%20in%20a%20ruined%20temple%2C%20warm%20golden%20light%20against%20deep%20shadow%2C%20dynamic%20painterly%20style&width=400&height=600&seq=bale-an-004&orientation=portrait",
    banner: "https://readdy.ai/api/search-image?query=Ruined%20ancient%20temple%20filled%20with%20glowing%20golden%20runic%20circles%20and%20floating%20debris%2C%20epic%20magical%20atmosphere%2C%20deep%20shadows%20for%20title%20text%2C%20painterly%20fantasy%20anime%20art&width=1600&height=900&seq=bale-bn-204&orientation=landscape",
    summary: "当沉睡千年的神域重新开启，凡人也要为自己争一个位置。",
    description: "传说中，众神离开之后留下了一片被封印的神域，里面封存着足以改变世界的力量。千年之后，封印出现裂痕，来自各地的冒险者纷纷涌向神域外围。出身平凡的主角在一次意外中得到了与神域共鸣的能力，也因此被卷入了各方势力的争夺之中。他必须在一片混乱里守住自己的信念，也要弄明白这份力量真正的代价。",
    actors: ["主角 饰 凯尔", "神官 饰 艾莉丝", "战士 饰 格罗"],
    director: "藤原拓海",
  },
  {
    id: "an-005",
    title: "黑龙传说",
    type: "动漫",
    genre: ["冒险", "奇幻", "剧情"],
    region: "中国大陆",
    year: 2024,
    updatedAt: "2024-07-21",
    episodes: "全20集",
    rating: 8.3,
    heat: 8360,
    cover: "https://readdy.ai/api/search-image?query=Chinese%20fantasy%20anime%20poster%20of%20a%20majestic%20black%20dragon%20coiling%20around%20a%20mountaintop%20pagoda%20at%20sunset%2C%20warm%20golden%20clouds%2C%20ink%20wash%20epic%20style&width=400&height=600&seq=bale-an-005&orientation=portrait",
    banner: "https://readdy.ai/api/search-image?query=Epic%20Chinese%20fantasy%20landscape%20of%20a%20black%20dragon%20coiling%20above%20cloud%20covered%20mountains%20at%20sunset%2C%20warm%20golden%20clouds%2C%20ink%20wash%20art%20with%20title%20space&width=1600&height=900&seq=bale-bn-205&orientation=landscape",
    summary: "守护神山千年的黑龙突然消失，少年的寻龙之路由此开始。",
    description: "传说在群山之巅，有一条守护人间千年的黑龙。可就在某一天，黑龙毫无征兆地消失了，山下的村落也因此灾祸不断。少年为了弄清真相，带着爷爷留下的一枚旧铃铛踏上寻龙之路。他先后遇到了隐世的老修士、倔强的猎户女儿和一只会说话的灵兽，一路揭开关于守护、承诺与选择的古老秘密。",
    actors: ["少年 饰 阿辰", "猎女 饰 阿岚", "灵兽 饰 小墨"],
    director: "云墨",
  },
  {
    id: "an-006",
    title: "猫咪咖啡屋",
    type: "动漫",
    genre: ["日常", "喜剧", "家庭"],
    region: "日本",
    year: 2022,
    updatedAt: "2022-08-15",
    episodes: "全12集",
    rating: 8.4,
    heat: 7180,
    cover: "https://readdy.ai/api/search-image?query=Cozy%20anime%20poster%20of%20a%20warm%20cat%20cafe%20interior%20with%20sleeping%20cats%20on%20cushions%20and%20steaming%20coffee%2C%20soft%20golden%20light%2C%20gentle%20healing%20atmosphere&width=400&height=600&seq=bale-an-006&orientation=portrait",
    banner: "https://readdy.ai/api/search-image?query=Warm%20inviting%20cat%20cafe%20interior%20with%20wooden%20furniture%2C%20plants%20and%20a%20few%20cats%20napping%20in%20golden%20afternoon%20light%2C%20cozy%20healing%20anime%20scene%20with%20title%20space&width=1600&height=900&seq=bale-bn-206&orientation=landscape",
    summary: "一间开在巷子深处的猫咪咖啡屋，收留迷路的猫，也收留迷路的人。",
    description: "在城市安静的角落里，有一间由老房子改造而成的猫咪咖啡屋。店主收养了几只性格各异的流浪猫，也接待着形形色色的客人。加班到深夜的上班族、刚失恋的女孩、独自过生日的老爷爷，都会在这里点一杯咖啡，被一只猫悄悄治愈。每一集都是一段温柔的日常，简单却让人安心。",
    actors: ["店主 饰 千夏", "常客 饰 直树", "猫 饰 小玉"],
    director: "高桥真守",
  },
  {
    id: "an-007",
    title: "星际旅人",
    type: "动漫",
    genre: ["科幻", "冒险", "剧情"],
    region: "美国",
    year: 2023,
    updatedAt: "2023-11-27",
    episodes: "全16集",
    rating: 8.4,
    heat: 8080,
    cover: "https://readdy.ai/api/search-image?query=Stylized%20sci-fi%20anime%20poster%20of%20a%20young%20traveler%20with%20a%20backpack%20looking%20at%20a%20ringed%20planet%20from%20a%20space%20port%2C%20warm%20orange%20glow%20and%20deep%20violet%20sky%2C%20painterly%20style&width=400&height=600&seq=bale-an-007&orientation=portrait",
    banner: "https://readdy.ai/api/search-image?query=Vast%20space%20port%20platform%20overlooking%20a%20ringed%20planet%20with%20warm%20orange%20sunrise%20and%20deep%20sky%2C%20stylized%20painterly%20sci-fi%20anime%20key%20art%20with%20title%20space&width=1600&height=900&seq=bale-bn-207&orientation=landscape",
    summary: "一个没有目的地的旅人，搭着各式各样的飞船，走遍了大半个星系。",
    description: "在那个星际旅行早已寻常的年代，有一个从不做长期计划的年轻人。他靠搭便车的方式往来于不同的星球之间，每到一处便打一份短工，认识一群新的朋友，然后又启程前往下一站。剧集以单元剧的形式展开，用一个个小而完整的故事，描绘宇宙尽头的烟火气息，也讲述关于归属与自由的选择。",
    actors: ["旅人 饰 里奥", "船长 饰 卡珊", "机械师 饰 波比"],
    director: "Alex Turner",
  },
  {
    id: "an-008",
    title: "热血篮球社",
    type: "动漫",
    genre: ["运动", "青春", "剧情"],
    region: "日本",
    year: 2024,
    updatedAt: "2024-10-14",
    episodes: "全26集",
    rating: 8.5,
    heat: 8720,
    cover: "https://readdy.ai/api/search-image?query=Sports%20anime%20poster%20of%20a%20determined%20teenager%20jumping%20to%20shoot%20a%20basketball%20in%20a%20sunlit%20gym%2C%20warm%20orange%20light%20and%20dynamic%20motion%2C%20energetic%20anime%20style&width=400&height=600&seq=bale-an-008&orientation=portrait",
    banner: "https://readdy.ai/api/search-image?query=Sunlit%20school%20gymnasium%20with%20a%20basketball%20hoop%20and%20dynamic%20motion%20of%20a%20player%20in%20mid%20air%2C%20warm%20orange%20afternoon%20light%2C%20energetic%20sports%20anime%20art%20with%20title%20space&width=1600&height=900&seq=bale-bn-208&orientation=landscape",
    summary: "一支连替补都凑不齐的篮球社，要向着全国大赛出发。",
    description: "学校篮球社因为连年战绩不佳，正面临被裁撤的危机。仅剩的五名队员各有各的问题：有人天赋出众却心态脆弱，有人努力却始终差一口气，还有人只是单纯地喜欢打球。为了保住社团，他们必须在新赛季打进地区赛。从最基础的体能训练开始，这群少年一点点把不可能变成了可能。",
    actors: ["后卫 饰 翔太", "队长 饰 隼人", "中锋 饰 大和"],
    director: "井上雄彦",
  },
];

export const typeCategories = [
  {
    key: "电影",
    slug: "movie",
    name: "电影",
    desc: "精彩大片尽在芭乐视频，动作、悬疑、科幻与温情佳作一站直达。",
    icon: "ri-film-line",
  },
  {
    key: "电视剧",
    slug: "tv",
    name: "电视剧",
    desc: "追剧不停歇，热播剧集与经典长剧每日更新，陪你度过每一个夜晚。",
    icon: "ri-tv-2-line",
  },
  {
    key: "动漫",
    slug: "anime",
    name: "动漫",
    desc: "热血、治愈与奇幻并存，国内外热门动漫新番同步更新。",
    icon: "ri-spectrum-line",
  },
];

export const bannerItems = [
  { id: "mv-001", tag: "本周热映", title: "星海孤舟", desc: "穿越未知星域，只为把人类的信号带回地球" },
  { id: "tv-001", tag: "年度口碑剧", title: "京华烟云录", desc: "一座宅院的兴衰，三代女性的命运" },
  { id: "an-001", tag: "新番热播", title: "剑与远方", desc: "少年背着一把不是自己的剑，踏上寻乡之旅" },
  { id: "tv-003", tag: "悬疑力作", title: "暗流", desc: "一桩失踪案，撕开港口城市水下利益网" },
  { id: "an-002", tag: "机甲巅峰", title: "机甲纪元", desc: "人类最后的防线，是一群还没长大的孩子" },
];

export const regionOptions = ["全部", "中国大陆", "中国香港", "美国", "日本", "韩国", "英国"];

export const yearOptions = ["全部", "2025", "2024", "2023", "2022", "2021"];

export const genreOptions = [
  "全部",
  "动作",
  "喜剧",
  "爱情",
  "科幻",
  "悬疑",
  "犯罪",
  "奇幻",
  "冒险",
  "剧情",
  "战争",
  "历史",
  "家庭",
  "青春",
  "运动",
];